module.exports = __webpack_public_path__ + "static/img/WiFi.5e3b4a6d.png";